<template>
<div class="list-view">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="text" class="search" placeholder="Search" v-model="filters.search_term" @keyup.enter="getList()" v-focus>
			<div class="button action input-go" @click="getList()"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination v-if="showPagination" :paging="paging" @updatePage="goToPage"></pagination>
			<button v-if="showDetail" class="neutral" @click="backToList()">Back To List</button>
		</div>
	</div>

	<div class="filters">

		<ul class="checkbox-group">
			<li>
				<span :class="['pointer', 'far', filters.on_hand ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('on_hand')"></span>
				<label>On Hand</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.disposed ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('disposed')"></span>
				<label>Disposed</label>
			</li>
		</ul>
		<div class="divider"></div>
		<div class="label-group">
			<label>Start</label>
			<input type="date" v-model="filters.start_date" :max="$today().clone().format('YYYY-MM-DD')">
		</div>
		<div class="label-group">
			<label>End</label>
			<input type="date" v-model="filters.end_date" :max="$today().clone().format('YYYY-MM-DD')">
		</div>
		<div class="label-group">
			<label></label>
			<div class="button small neutral" @click="getList(1)">Filter Dates</div>
		</div>

		<div class="label-group">
			<label></label>
			<div class="checkbox-group">
				<span :class="['pointer', 'far', !filters.start_date && !filters.end_date ? 'disabled' : '', filters.use_date_received ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('use_date_received')"></span>
				<label>Received</label>
				<span :class="['pointer', 'far', !filters.start_date && !filters.end_date ? 'disabled' : '', filters.use_date_disposed ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('use_date_disposed')"></span>
				<label>Disposed</label>
			</div>
		</div>

		<div class="divider"></div>
		<div :class="['button', hasFilters ? 'neutral' : 'disabled' ]" @click="clearFilters(true)">Clear Filters</div>
		<div :class="['extra-menu-item', { 'disabled': list.length < 1 }]" @click="showPDFOptions = true" target="_blank">Print Report</div>
	</div>

    <!-- <loading v-if="loading"></loading> -->

	<div v-if="!showDetail" class="list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list">Receipt Date</th>
					<th class="list">MFG / IMP</th>
					<th class="list">Type</th>
					<th class="list">Model</th>
					<th class="list">Serial Number</th>
					<th class="list">Caliber</th>
				</tr>
			</thead>
			<tr v-for="(item, index) in list" class="clickable-list-item" @click="getDetail(item.ffl_log_book_entry_id)">
				<td class="list">{{ item.receipt_date }}</td>
				<td class="list">{{ item.manufacturer }}</td>
				<td class="list">{{ item.gun_type }}</td>
				<td class="list">{{ item.model }}</td>
				<td class="list">{{ item.serial_number }}</td>
				<td class="list">{{ item.caliber }}</td>
			</tr>
		</table>

	</div>

	<div v-if="showDetail" class="detail">
		<logbook-entry-detail :entry="detail" :hideControls="true" @cancel="backToList()"></logbook-entry-detail>
	</div>

	<div class="modal" v-if="showPDFOptions">
		<div class="inner">
			<h2>Print Report</h2>
			<div class="content">
				<div v-if="filters.start_date && filters.end_date" >
					<p>Identify whether this is an initial or follow-up report...</p>
					<p class="center">
						<binary-toggle v-model="reportType" labels="Initial,Follow-up" values="I,F" :key="'report_type_' + reportType" />
					</p>
				</div>
				<div v-else>
					<p>Please select a date range before printing this report.</p>
				</div>
			</div>
			<div class="controls">
				<div class="button neutral spaced" @click="showPDFOptions = false">Cancel</div>
				<div v-if="filters.start_date && filters.end_date" class="button action spaced" @click="doPrintPDF()">Print</div>
			</div>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

</div>
</template>

<script>
import ListDetail from '../components/ListDetail'
import BinaryToggle from '@/components/BinaryToggle.vue'
export default {
	name: 'used-gun-report',
    components: {
        'logbook-entry-detail': ListDetail,
        'binary-toggle': BinaryToggle
    },
	data() {
		return {
            loading: false,
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			page: 1,
			showPagination: false,
			clientId: '',
			filters: {
				page: 1,
				is_used: true,
				use_date_received: true,
				use_date_disposed: false,
				on_hand: false,
				disposed: false,
				search_term: '',
				start_date: '',
				end_date: ''
			},
			list: [],
			paging: {},
			showDetail: false,
			detail: {},
			showPDFOptions: false,
			reportType: 'I'
		}
	},
    created() {
		var threeMonthsAgo = new Date()
		threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() -3)
		this.filters.start_date = threeMonthsAgo.toISOString().slice(0,10)
		this.filters.end_date = new Date().toISOString().slice(0,10)
		this.getList()
    },
	computed: {
		hasFilters() {
			return this.filters.use_date_received || this.filters.use_date_disposed || this.filters.on_hand || this.filters.disposed || this.filters.start_date || this.filters.end_date || this.filters.search_term
		}
	},
	methods: {
		getList() {
			if (this.loading) { return }
			this.loading = true
			this.message = 'Loading report...'
			this.messageStatus = 'waiting'
			this.showDetail = false
			this.detailChanged = false
			this.apiCall({ destination: 'get_list_ffl_log_book_entries', data: this.filters }).then(obj => {
                this.loading = false
				this.messageStatus = obj.status
				this.message = ''
				this.list = obj.list_data
				this.paging = obj.paging
				this.clientId = obj.client_id
				this.showPagination = true
			}).catch(err => {
                this.loading = false
				console.log(err)
			})
		},
		getDetail(getItemId) {
			this.apiCall({ destination: 'get_item_ffl_log_book_entry', data: { ffl_log_book_entry_id: getItemId } }).then(obj => {
				this.detail = obj.entry
				this.showDetail = true
				this.showPagination = false
			}).catch(err => {
				console.log(err)
			})
		},
		backToList() {
			this.showDetail = false
			this.detail = {}
			this.showPagination = true
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		clearFilters() {
			if (!this.hasFilters) { return }
			this.filters = {
				page: 1,
				is_used: true,
				use_date_received: true,
				use_date_disposed: false,
				on_hand: false,
				disposed: false,
				search_term: ''
			}
			var threeMonthsAgo = new Date()
			threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() -3)
			this.filters.start_date = threeMonthsAgo.toISOString().slice(0,10)
			this.filters.end_date = new Date().toISOString().slice(0,10)
			this.getList()
		},
		toggleFilter(which) {
			// use_date_received and use_date_disposed are disabled without start or end date
			if (which == 'use_date_received' || which == 'use_date_disposed') {
				if (!this.filters.start_date && !this.filters.end_date) {
					return false;
				}
				if (which == 'use_date_received') {
					this.filters.use_date_disposed = false
				} else {
					this.filters.use_date_received = false
				}
			}
			this.filters[which] = !this.filters[which]
			this.filters.page = 1
			this.getList()
		},
		doPrintPDF() {
			let pdfLink = this.getPDFAPIEndpoint + '?action=form_5300_5_pdf&start_date=' + this.filters.start_date + '&end_date=' + this.filters.end_date + '&type=' + this.reportType + '&fd_token=' + getCookie('dashboard_token')
			window.open(pdfLink, '_blank');
			this.showPDFOptions = false
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
